import styled from 'styled-components';

export const MemoTextArea = styled.textarea`
	width: calc(100%);
	padding: 16px;

	border-radius: 16px;
	border: none;
	background-color: ${({ theme }) => theme['warmgray-50']};

	color: #0e0d0c;
	font-style: normal;
	text-decoration: none;
	word-break: keep-all;
	text-overflow: ellipsis;
	font-family: 'Pretendard';
	font-weight: 400;
	font-size: 14px;
	line-height: 24px;

	resize: none;
`;
